(function () {
    'use strict';

    function searchController($scope, $log, searchConfiguration, sessionData) {
        var vm = this;
        vm.config = searchConfiguration;
        vm.sessionData = sessionData;
        vm.results = [];
        vm.showResults = false;
        vm.attributes = {};

        vm.pageSizes = [5, 10, 15, 20, 25];

        vm.doAction = function(entity) {
            entity.isSelected = !entity.isSelected;
        }
    }

    searchController.$inject = ['$scope', '$log', 'searchConfiguration', 'sessionData'];

    angular.module('ecap.dashboards').controller('searchController', searchController);
})();
